


















































































import Vue, { PropType } from 'vue';
import FieldCheckbox from '@/components/form/FieldCheckbox.vue';
import Button from '@/components/form/Button.vue';
import { Column, ColumnItems, ColumnType } from './types';
import { EAlignTableCell } from '@/types';
import toLocaleString from '@/utils/toLocaleString';

export default Vue.extend({
  name: 'TableBodyCell',
  components: { FieldCheckbox, Button },

  props: {
    value: {
      type: [String, Number],
      required: true,
      default: '',
    },
    column: {
      type: Object as PropType<Column>,
      required: true,
      default: null,
    },
  },

  watch: {
    column(newValue) {
      this.columnAlign = newValue.align;
    },
  },

  computed: {
    typeText(): string {
      return ColumnType.TYPE_TEXT;
    },
    typeColors(): string {
      return ColumnType.TYPE_COLORS;
    },
    typeButtonIcon(): string {
      return ColumnType.TYPE_BUTTON_ICON;
    },
    typeImage(): string {
      return ColumnType.TYPE_IMG;
    },
    typeCheckbox(): string {
      return ColumnType.TYPE_CHECKBOX;
    },
    typeButton(): string {
      return ColumnType.TYPE_BUTTON;
    },
    emptyValue(): string {
      return '-';
    },
    checkStatusItem(): ColumnItems | null {
      const item = this.column.items?.find((item) => item.value === this.value);

      if (item) {
        return item;
      }

      return null;
    },
    alignLeft(): boolean {
      return this.columnAlign === EAlignTableCell.LEFT;
    },
    alignCenter(): boolean {
      return this.columnAlign === EAlignTableCell.CENTER;
    },
    alignRight(): boolean {
      return this.columnAlign === EAlignTableCell.RIGHT;
    },
    alignClasses(): any {
      return {
        'justify-start': this.alignLeft,
        'justify-center': this.alignCenter,
        'justify-end': this.alignRight,
      };
    },
  },

  methods: {
    cellEvent(value) {
      this.$emit('bodyCellEvent', value);
    },
    formatValue(value: number) {
      return toLocaleString(value);
    },
  },

  data() {
    return {
      columnAlign: this.column.align || EAlignTableCell.LEFT,
    };
  },
});
